import React from "react";
import { cn } from "../../../common/u1/cn";

/* The callback form's field furniture. */

/* Shared by every control in the form, and by DialPhoneField. */
export const CONTROL =
  "w-full box-border rounded-lg border px-3 py-2.5 text-[13.5px] font-sans " +
  "text-[var(--navy)] bg-white outline-none transition-colors";

export const controlBorder = (invalid) =>
  invalid ? "border-[var(--danger)]" : "border-[var(--slate-3)]";

export const FieldLabel = ({ children, htmlFor }) => (
  <label htmlFor={htmlFor} className="text-[11.5px] font-semibold text-[var(--trade-body)] font-sans">
    {children}
  </label>
);

export const FieldError = ({ id, children }) =>
  children ? (
    <span id={id} role="alert" className="text-[12px] text-[var(--danger)] font-sans">
      {children}
    </span>
  ) : null;

/* Label, control and message in the one stack every field uses.
 *
 * The error is wired to the control with aria-describedby and aria-invalid so
 * it is announced, not just reddened — the live form colours the border only. */
export const Field = ({ id, label, error, children, className = "" }) => (
  <div className={cn("flex flex-col gap-1.5", className)}>
    {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
    {children}
    <FieldError id={error ? `${id}-error` : undefined}>{error}</FieldError>
  </div>
);

/* The dropdown surface shared by "How can we help?" and the dial picker. */
export const MENU =
  "absolute left-0 top-[46px] z-40 rounded-[11px] border border-[var(--form-line)] " +
  "bg-white p-1.5 shadow-[shadow:var(--drop-shadow-menu)]";

/* A menu option. Hover is a class, not two mouse handlers writing inline
   styles as the live form does. */
export const MENU_ROW =
  "flex w-full cursor-pointer items-center gap-2.5 rounded-lg px-2.5 py-2 " +
  "text-left text-[13px] font-sans text-[var(--navy)] hover:bg-[var(--row-hover)]";

export default Field;
